import { apiUrl2 } from '../../settings'

export const cyprusFamTourAppUrl = () => {
  return apiUrl2 + '/api/cyprus-fam-tour'
}

export const applyForCyprusFamTourAppUrl = () => {
  return apiUrl2 + '/api/apply-for-cyprus-fam-tour'
}

export const interestForCyprusFamTourAppUrl = () => {
  return apiUrl2 + '/api/interest-for-cyprus-fam-tour'
}
